import React from 'react';
import './About.css';

const AboutUs = () => {

  const founderArray = [
    { name: "Bhavani Tammaneni", 
      position: "Director",
      images: "/images/founder_image.jpg",
      quote1: `We firmly believe that technology has the power to transform lives and uplift society. 
      With this vision in mind, we identified drones as a key enabler—offering immense potential 
      to address real-world challenges and improve everyday life. The field of drone technology is still evolving,
      and there remains tremendous opportunity for innovation and impact.`,

      quote2: `At the core of our mission is the drive to bring world-class technology into the drone space, making it more 
      accessible, efficient, and beneficial for people across various sectors. 
      We are committed to putting our expertise and passion into creating solutions that not only advance 
      the industry but also serve the greater good of society.`

    },
    { name: "Sanikommu Balakrishna Reddy", 
      position: "Director",
      images: "/images/founder.jpg",
      quote1: `The success of any company is fundamentally rooted in customer satisfaction. 
      At our core, we are deeply committed to delivering drone products and services 
      that meet the highest standards of quality and performance.`,

      quote2: `We take pride in building world-class solutions that not only meet but exceed 
      our customers’ expectations. Our goal is to ensure every interaction reflects 
      our dedication to excellence, reliability, and customer-centric innovation—ultimately 
      achieving complete satisfaction in every project we undertake.`
    },
  ]

  
  return (
    <div className="aboutus">
      <div className="aboutus_box">
        <div className="aboutus_box_hero">
          <div className="aboutus_box_hero_left">
            <h1> About Us</h1>
            <p>We are to develop versatile unmanned systems for various industries, 
              including drones capable of serving in delivery services, agriculture, 
              defence, surveillance, games, and entertainment.</p>
          </div>
          <div className="aboutus_box_hero_right">
            <img src="/images/Photography_Videography.jpg" alt="Drone" />
          </div>
        </div>
        

        <div className="aboutus_box_vision">
          <div className="aboutus_box_vision_left">
            <img src="/images/Photography_Videography_drone.png" alt="Drone" />
          </div>
          <div className="aboutus_box_vision_right">
            <h2> Vision </h2>
            <p>To bring Artificial Inrelligence to the doorstep of everyday's life to enhance Society.</p>
            <h2> Mission </h2>
            <p>To build Drones and Bots which will enhance quality of life on this planet.</p>
          </div>
        </div>

        <div className="aboutus_box_values_title">
          <h2>Our Values</h2>
        </div>

        <div className="aboutus_box_our_values">
          <div className="value_cards">
          <img src="/images/innovation.png" alt='innovation'/>
            <h3>Innovation</h3>
            <p>Drone innovation enhances flight performance, imaging, and versatility across various real-world applications.</p>
          </div>

          <div className="value_cards">
          <img src="/images/transparency.png" alt='transparency'/>
            <h3>Transparency</h3>
            <p>Transparency in drones ensures clear communication, responsible usage, and accountability in data collection and operations.</p>
          </div>

          <div className="value_cards">
          <img src="/images/Quality.png" alt='quality'/>
            <h3>Quality</h3>
            <p>Be decisive, act proactively to solve problems, seek & provide help, and guide others to avoid mistakes.</p>
          </div>

          <div className="value_cards">
          <img src="/images/integrity.png" alt='integrity'/>
            <h3>Integrity</h3>
            <p>Be decisive, act proactively to solve problems, seek & provide help, and guide others to avoid mistakes.</p>
          </div>

          <div className="value_cards">
          <img src="/images/Team_Work.png" alt='team work'/>
            <h3>Team Work</h3>
            <p>Be decisive, act proactively to solve problems, seek & provide help, and guide others to avoid mistakes.</p>
          </div>

          <div className="value_cards">
          <img src="/images/Customer_Satisfaction.png" alt='customer satisfaction'/>
            <h3>Customer Satisfaction</h3>
            <p>Be decisive, act proactively to solve problems, seek & provide help, and guide others to avoid mistakes.</p>
          </div>
        </div>
        
        <div className="aboutus_box_story">
          <div className="aboutus_box_story_left">
            <h2> Our Story </h2>
            <p>
              Founded in 2023 by Bhavani Tammaneni and Balakrishna Reddy Sanikoummu, our company was established with a bold vision: 
              to revolutionize the drone industry through innovative, cost-effective, and locally developed solutions.
              <br/>
              <br/>
              We specialize in developing and delivering high-performance drone products and services that cater 
              to a wide range of applications, including 
              Agricultural solutions for crop monitoring and precision spraying
              Aerial photography and videography for creative and commercial use
              Surveillance systems for security and monitoring
              Surveying and mapping for land analysis, infrastructure, and development projects.
              <br/>
              <br/>
              By localizing the development of most drone components in India, we significantly reduce costs and increase accessibility, 
              empowering industries and communities with reliable, advanced aerial technologies.
              With a strong focus on innovation, quality, and efficiency, we are building a future 
              where drones are an integral part of everyday operations—designed, built, and supported right here in India.
            </p>
          </div>
          <div className="aboutus_box_story_right">
            {/* <img src={images}/> */}
            <img src="/images/Photography_Videography_drone.png" alt="Drone" />
          </div>
        </div>
        
        <div className="aboutus_box_founder_title">
          <h2>Founders</h2>
         {/* </div> */}
          <div className="aboutus_box_founder">
            <div className="aboutus_box_founder_wrapper">
              {founderArray.length === 1 ? (
                // Layout for single founder
                <div className="aboutus_box_founder_section single-founder">
                  <div className="aboutus_box_founder_text">
                    <span className="quote-mark">❝</span>
                    <p className="quote-text">{founderArray[0].quote1}</p>
                    <p className="quote-text">{founderArray[0].quote2}</p>
                    <h3>{founderArray[0].name}</h3>
                    <p>{founderArray[0].position}</p>
                  </div>
                  <div className="aboutus_box_founder_img_hexagon">
                    <div className="hexagon">
                      <img src={founderArray[0].images} alt={founderArray[0].name} />
                    </div>
                  </div>
                </div>
              ) : (
                // Layout for multiple founders
                founderArray.map((el, i) => (
                  <div className="aboutus_box_founder_section" key={i}>
                    <div className="aboutus_box_founder_text">
                      <span className="quote-mark">❝</span>
                      <p className="quote-text">{el.quote1}</p>
                      <p className="quote-text">{el.quote2}</p>
                      <h3>{el.name}</h3>
                      <p>{el.position}</p>
                    </div>
                    <div className="aboutus_box_founder_img_hexagon">
                      <div className="hexagon">
                        <img src={el.images} alt={el.name} />
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div> 

        <div className='about_box_title'>
          <h2>Our Team</h2>
          <p>
            We are a team of passionate individuals committed to innovation and excellence.
          </p>
        
          <div className='about_box_groupimage'>
            <img 
              src="/images/our_team.jpeg"
              alt="Our Team Group"
              className="about_box_groupimage_img"
            />
          </div>
        </div>
        <div className="aboutus_box_title">
          <h2>Fast Facts</h2>
          <p>
            we'r impartial and independent, and every day we create 
            distinctive, world-class programes and content 
          </p>
        </div>

        {/* <div className="aboutus_box_facts">
          <div className="aboutus_box_facts_box">
            {factsArray.map((el, i)=> (
              <div className="aboutus_box_facts_box_info" key={i}>
                <h3>{el.title}</h3>
                <p>{el.info}</p>
              </div>
            ))}
          </div>
        </div> */}
      </div>
    </div>
  )
}

export default AboutUs
